import { ClientInfo } from "../../Domain/ClientInfo/FormsClientInfo";

export enum RequisitesType {
    FormsClientInfo,
}

export interface RequisitesSet {
    type: RequisitesType.FormsClientInfo;
    content: ClientInfo;
}

export interface RequisitesSetEntry {
    name: string;
    value: RequisitesSet;
}
